"use client";
import React, { useState } from "react";
import data from "../../data/blog/forthwroth.json";

function Content() {
  const blogData = data[1];
  const [id, SetId] = useState(false);
  return (
    <div className="max-w-5xl px-4 mx-auto">
      {blogData.Mainheading.map((item, index) => (
        <div key={index} className="">
          {/* Add spacing between heading and its content */}
          <h2
            id={item.id}
            className={`blogSubtitle ${id ? "bg-red-400" : ""}  `}
          >
            {item.title}
          </h2>
          {/* <h2 id={item.id} className="blogtitle">{item.title}</h2> */}
          <p
            className="blogcontent"
            dangerouslySetInnerHTML={{ __html: item.content }}
          ></p>

          {/* Terminal specific content */}
          {item.terminal && (
            <div id={item.id || item.id1} className="blogSubtitle">
              {item.terminal}
            </div>
          )}

          {/* Image */}
          {item.image && (
            <img
              src={item.image}
              alt={item.title}
              className=" rounded-lg mb-4"
            />
          )}

          <div className=" text-[#2B3252] ">
            {/* Additional content sections */}

            {item.content2 && (
              <div
                className="blogcontent"
                dangerouslySetInnerHTML={{ __html: item.content2 }}
              />
            )}
            {item.content3 && (
              <div
                className="blogcontent"
                dangerouslySetInnerHTML={{ __html: item.content3 }}
              />
            )}

            {item.content4 && item.content4.trim() && (
              <div
                className="blogcontent"
                dangerouslySetInnerHTML={{ __html: item.content4.trim() }}
              />
            )}
          </div>
        </div>
      ))}
    </div>
  );
}

export default Content;
